import { initContract } from "@ts-rest/core";
import { z } from "zod";
import { Base64 } from "js-base64";
import { loyaltyContract } from "./loyalty";
import { quickbuyContract } from "./quickbuy";
import { sellingPlanGroupsContract } from "./sellingPlanGroups";
import { ApiErrorSchemas } from "../utils";
import { getShopifyGidPrefix } from "../../utils/ensureShopifyGid";
import { billsContract } from "./bills";

const contractInstance = initContract();

export const baseHeadersSchema = z.object({
  "x-customer-portal-exp": z.coerce.number().refine(
    num => {
      const expirationDate = new Date(num);
      return new Date() < expirationDate;
    },
    { message: "session has expired" }
  ),
  "x-customer-portal-signature": z.string().refine(Base64.isValid, { message: "signature must be in base64" }),
  "x-shopify-customer-id": z.string().startsWith(getShopifyGidPrefix("Customer")),
  "x-shopify-shop-domain": z.string().endsWith(".myshopify.com"),
});

export const customerContract = contractInstance.router(
  {
    quickBuy: quickbuyContract,
    loyalty: loyaltyContract,
    bills: billsContract,
    sellingPlanGroups: sellingPlanGroupsContract,
  },
  {
    jsonQuery: true,
    pathPrefix: "/customer",
    commonResponses: {
      401: ApiErrorSchemas.unauthorizedErrorSchema,
      500: ApiErrorSchemas.serverErrorSchema,
    },
    baseHeaders: baseHeadersSchema,
  }
);
